import config from '../config'
import {
  IPlanSubscriptionDetails,
  PlanSubscriptionFilter,
  PaginatedPlanSubscriptions,
} from '../pages/plan-subscriptions-container/share-type'
import { authRequest } from '../request'

const { mainApi } = config
const baseUrl = `${mainApi}/plan-subscriptions`

export const getPlanSubscriptions = (params: PlanSubscriptionFilter) =>
  authRequest.get<MISSING_TYPE, PaginatedPlanSubscriptions>(baseUrl, { params })

export const getPlanSubscription = (id: number) =>
  authRequest.get<MISSING_TYPE, IPlanSubscriptionDetails>(`${baseUrl}/${id}`)

export const cancelPlanSubscriptionAutoRenewal = (id: number) =>
  authRequest.post<MISSING_TYPE, void>(`${baseUrl}/${id}/cancel-auto-renew`)
